import { effect, Injectable, signal } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { FilterGeneratorService } from './filter-generator.service';
import { FilterService } from './filter.service';

@Injectable({
  providedIn: 'root'
})
export class FilterOutputService {
  readonly formattedFilterText = signal<SafeHtml | undefined>(undefined);

  private inViewport = false;
  private formattedFromFilterText?: string;

  constructor(
    private filterService: FilterService,
    private filterGeneratorService: FilterGeneratorService,
  ) {
    effect(() => {
      const filterText = this.filterService.filterResultData().filterText;
      if (this.inViewport) {
        this.refreshFormattedFilterText(filterText);
      } else if (filterText !== this.formattedFromFilterText) {
        this.formattedFromFilterText = filterText;
        this.formattedFilterText.set(undefined);
      }
    });
  }

  setInViewport(inViewport: boolean): void {
    if (this.inViewport === inViewport) return;
    this.inViewport = inViewport;
    if (inViewport) {
      this.refreshFormattedFilterText(this.filterService.filterResultData().filterText);
    }
  }

  ensureFormattedFilterText(): SafeHtml | undefined {
    return this.refreshFormattedFilterText(this.filterService.filterResultData().filterText);
  }

  private refreshFormattedFilterText(filterText: string): SafeHtml | undefined {
    if (!filterText) {
      this.formattedFromFilterText = filterText;
      this.formattedFilterText.set(undefined);
      return undefined;
    }

    if (filterText === this.formattedFromFilterText && this.formattedFilterText()) {
      return this.formattedFilterText();
    }

    const formatted = this.filterGeneratorService.formatFilterTextWithRuleMarkers(filterText);
    this.formattedFromFilterText = filterText;
    this.formattedFilterText.set(formatted);
    return formatted;
  }
}
